import React from 'react';
import './FilterBar.css';

function getUniqueOptions(data, col) {
    return Array.from(new Set(data.map(row => row[col]).filter(Boolean))).sort();
}

const FilterBar = ({ columns, data, filters, setFilters, filterColumns }) => {
    // Handle chip click (multi-select)
    const handleChip = (col, value) => {
        setFilters(prev => {
            const prevVals = prev[col] || [];
            if (prevVals.includes(value)) {
                return { ...prev, [col]: prevVals.filter(v => v !== value) };
            } else {
                return { ...prev, [col]: [...prevVals, value] };
            }
        });
    };

    // Handle dropdown/select
    const handleSelect = (col, value) => {
        setFilters(prev => ({ ...prev, [col]: value }));
    };

    // Clear all filters
    const clearAll = () => setFilters({});

    return (
        <div className="filter-bar">
            {filterColumns.map(col => {
                const options = getUniqueOptions(data, col);
                // For year, show as dropdown
                if (col === 'Year') {
                    return (
                        <div className="filter-group" key={col}>
                            <span className="filter-label">{col}:</span>
                            <button
                                className={
                                    'filter-chip all' +
                                    (!filters[col] || filters[col].length === 0 ? ' selected' : '')
                                }
                                onClick={() => setFilters(prev => ({ ...prev, [col]: [] }))}
                            >
                                All
                            </button>
                            {options.map(opt => (
                                <button
                                    key={opt}
                                    onClick={() => handleChip(col, opt)}
                                    className={
                                        'filter-chip' +
                                        ((filters[col] || []).includes(opt) ? ' selected' : '')
                                    }
                                >
                                    {opt}
                                </button>
                            ))}
                        </div>
                    );
                }
                // Otherwise, show as filter chips
                return (
                    <div className="filter-group" key={col}>
                        <span className="filter-label">{col}:</span>
                        <button
                            className={
                                'filter-chip all' +
                                (!filters[col] || filters[col].length === 0 ? ' selected' : '')
                            }
                            onClick={() => setFilters(prev => ({ ...prev, [col]: [] }))}
                        >
                            All
                        </button>
                        {options.map(opt => (
                            <button
                                key={opt}
                                onClick={() => handleChip(col, opt)}
                                className={
                                    'filter-chip' +
                                    ((filters[col] || []).includes(opt) ? ' selected' : '')
                                }
                            >
                                {opt}
                            </button>
                        ))}
                    </div>
                );
            })}
            <button className="clear-all-btn" onClick={clearAll}>
                Clear All Filter
            </button>
        </div>
    );
};

export default FilterBar;